import { Button, Col, List, Row, Typography } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as ArrowIcon } from '../../assets/svg/icons/chevron-right.svg';
import { ReactComponent as DotIcon } from '../../assets/svg/icons/dot.svg';
import { ReactComponent as PinSmall } from '../../assets/svg/icons/pin-small.svg';
var PinnedMessagesSlider = function (_a) {
    var data = _a.data, getMessage = _a.getMessage;
    var _b = useState(0), messageIndex = _b[0], setMessageIndex = _b[1];
    var _c = useState(true), isFirstClick = _c[0], setIsFirstClick = _c[1];
    useEffect(function () {
        if (!isFirstClick) {
            var message = data.find(function (_, index) { return index === messageIndex; });
            if (message) {
                getMessage(message.id);
            }
        }
    }, [messageIndex]);
    var handlePress = function () {
        if (isFirstClick) {
            var message = data.find(function (item, index) { return index === messageIndex; });
            if (message) {
                getMessage(message.id);
            }
        }
        else {
            setMessageIndex(function (prevState) {
                if (data.length === 1) {
                    return 0;
                }
                else if (data.length === 2 && prevState === 1) {
                    return 0;
                }
                else if (prevState === 2) {
                    return 0;
                }
                return prevState + 1;
            });
        }
        setIsFirstClick(false);
    };
    var dots = useMemo(function () {
        return data.map(function (_, index) {
            return React.createElement(DotIcon, { key: index, className: index === messageIndex ? 'active' : 'unactive' });
        });
    }, [data, messageIndex]);
    return (React.createElement(List, { itemLayout: "horizontal", className: "pinned-messages-carousel", dataSource: data.filter(function (_, index) { return index === messageIndex; }), renderItem: function (item) { return (React.createElement(List.Item, { onClick: handlePress },
            React.createElement(Col, { className: "pinned-messages-carousel-dots" }, dots),
            React.createElement(Col, { style: { flexBasis: '90%' } },
                React.createElement(Row, { align: 'middle' },
                    React.createElement(PinSmall, null),
                    React.createElement(Typography.Title, { level: 2, style: { fontSize: '12px', paddingLeft: '4px', margin: 0 } }, item.title)),
                React.createElement(Typography.Text, { className: "pinned-messages-carousel-description" }, item.description)),
            React.createElement(Button, { type: "link", className: "pinned-messages-carousel-arrow-button", icon: React.createElement(ArrowIcon, { style: { width: '0.7rem' } }) }))); } }));
};
export default PinnedMessagesSlider;
